import { PermissionEnum } from 'app/common/enum'
import { BaseSpace } from 'app/components/common/BaseSpace'
import { useVerifyPermission } from 'app/helpers/permission.helper'
import { useAppDispatch } from 'app/redux/hooks'
import { getUserInfo } from 'app/redux/slices/userSlice'
import React, { useCallback, useEffect } from 'react'
import { DashboardAdminLayout, DashboardMemberLayout } from './layouts'
import { ScrollWrapper } from './styles'

const DashboardContainer: React.FC = () => {
  const dispatch = useAppDispatch()

  const { user, verifyPermission } = useVerifyPermission()

  const renderLayout = useCallback(() => {
    if (!user?.member?.id) {
      return <DashboardAdminLayout />
    }

    return (
      <BaseSpace size={16}>
        {verifyPermission(PermissionEnum.DashboardAdmin) ? (
          <DashboardAdminLayout />
        ) : null}
        <DashboardMemberLayout />
      </BaseSpace>
    )
  }, [user])()

  useEffect(() => {
    dispatch(getUserInfo())
  }, [])

  return <ScrollWrapper>{renderLayout}</ScrollWrapper>
}

export default DashboardContainer
